import {
  CommonDT,
  DateFilter,
  PageParams,
  ResultType,
  Sorter,
} from "../../CommonDT";
import { _delete, _get, _post, _put, _req } from "../../request";

export type BillDataType = {
  uuid: string; // 主键 UUID
  billRecordType: string; // 记录类型（1签到，2拉新，3新用户，4消耗）
  billMoneyType: string; // 记账货币（1积分，2余额）
  billMoney: number; // 金额 (decimal 转为 number)
  billDatetime: string; // 日期时间 (datetime 通常处理为 ISO 格式的字符串)
  billRemark: string; // 备注
  fkUserUuid: string; // 外键用户 UUID
};

export type BillBatchDataType = {
  bills: BillDataType[];
};

export type BillPageDataType = {
  pageParams: PageParams;
  filter?: BillDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get("/usr/bill/", id);
};

const list = async (data?: BillDataType): Promise<ResultType> => {
  return await _post("/usr/bill/list", data);
};

const page = async (data?: BillPageDataType): Promise<ResultType> => {
  return await _post("/usr/bill/page", data);
};

const batchSave = async (data: BillBatchDataType): Promise<ResultType> => {
  return await _post("/usr/bill/batchSave", data);
};

const batchUpdate = async (data: BillBatchDataType): Promise<ResultType> => {
  return await _put("/usr/bill/batchUpdate", data);
};

const alterStatus = async (
  billId: string,
  status: number
): Promise<ResultType> => {
  return await _req("/usr/bill/alterStatus", "PUT", { billId, status });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete("/usr/bill/batchRemove", ids);
};

const listByUserId = async (
  userId: string,
  billIncomeType?: number,
  billMoneyType?: number
): Promise<ResultType> => {
  return await _req("/usr/bill/listByUserId", "GET", {
    userId,
    billIncomeType,
    billMoneyType,
  });
};

const BillApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  listByUserId,
};

export default BillApi;
